import { render, staticRenderFns } from "./contact-card.vue?vue&type=template&id=fbd1dd22"
import script from "./contact-card.vue?vue&type=script&lang=ts"
export * from "./contact-card.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbd1dd22')) {
      api.createRecord('fbd1dd22', component.options)
    } else {
      api.reload('fbd1dd22', component.options)
    }
    module.hot.accept("./contact-card.vue?vue&type=template&id=fbd1dd22", function () {
      api.rerender('fbd1dd22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contact-card/contact-card.vue"
export default component.exports